import { render, staticRenderFns } from "./CoverLetter.vue?vue&type=template&id=748ef0c1&scoped=true&"
import script from "./CoverLetter.vue?vue&type=script&lang=js&"
export * from "./CoverLetter.vue?vue&type=script&lang=js&"
import style0 from "./CoverLetter.vue?vue&type=style&index=0&id=748ef0c1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748ef0c1",
  null
  
)

export default component.exports